import { ComposeFormStore } from 'owa-calendar-compose-types';
import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';

interface ComposeStoreManager {
    storeMap: ObservableMap<string, ComposeFormStore>;
}

const initialComposeStoreManager: ComposeStoreManager = {
    storeMap: new ObservableMap(),
};

export const getComposeStoreManager = createStore<ComposeStoreManager>(
    'composeFormStore',
    initialComposeStoreManager
);
